export const BASE_FONT_SIZE = 16
export const LINE_HEIGHT_RATIO = 1.4
export const SCALE_RATIO = (1 + Math.pow(5, 0.25)) / 2 // "Half-step" Golden Ratio
